import { Stack } from '@chakra-ui/react'
import { flexGroupListContext } from 'brokertslib/src/context'
import {
  useUserFlexGroups
} from 'brokertslib/src/hooks/useFlexGroup'
import { noop } from 'lodash'

import {
  FlexGroupList
} from '../flex-group/FlexGroupList'
import { SectionHeading } from '../shared/SectionHeading'

export const UserFlexGroups = ({ userId }: { userId: string }) => {
  const { flexGroups, isLoading, refetch } = useUserFlexGroups(userId)

  if (isLoading || flexGroups?.length === 0)
    return

  return (
    <Stack>
      <SectionHeading>Přidělené flexibilní skupiny</SectionHeading>

      <flexGroupListContext.Provider
        value={{
          loading: isLoading,
          totalCount: flexGroups?.length ?? 0,
          currentPage: 1,
          pageSize: 10,
          filter: { showInvalid: false, pageIndex: 1 },
          setCurrentPage: noop,
          setPageSize: noop,
          updateFilter: noop,
          reload: () => refetch(),
        }}
      >
        <FlexGroupList
          flexGroups={flexGroups ?? []}
        />
      </flexGroupListContext.Provider>
    </Stack>
  )
}
